import React from 'react';
import { MessageCircle, Instagram } from 'lucide-react';
import { openWhatsApp } from '../../lib/whatsapp';

export const KundaliHero = () => {
  const handleBookConsult = () => {
    openWhatsApp('Namaste Nitika Ji, I would like to book a consultation.');
  };

  const scrollToServices = () => {
    const el = document.getElementById('services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/174d3dc0-fc62-4218-9cf1-1e8c201ee567/images/6df74ec730cf3c3f863134f7a14cff874d1b948f581022622b52c0d79bb292c8.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-[#0A0000]/85 to-[#0A0000]" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20 text-center max-w-2xl">
        {/* Portrait */}
        <div className="flex justify-center mb-5">
          <div
            className="relative rounded-full overflow-hidden border border-[#D4AF37]/45"
            style={{
              width: '112px',
              height: '112px',
              boxShadow: '0 0 0 4px rgba(212,175,55,0.10), 0 8px 24px rgba(212,175,55,0.18)'
            }}
          >
            <img
              src="https://customer-assets.emergentagent.com/job_starlight-readings-1/artifacts/kaq8ldqa_70CFEB64-2E42-4215-8E19-DD5642367B64.png"
              alt="Nitika Bhola — Astrologer, Tarot Reader and Numerologist"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Name */}
        <p className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] mb-1 font-medium">
          Nitika Bhola
        </p>

        {/* Instagram Handle */}
        <a
          href="https://www.instagram.com/nitikabhola_astro"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[#A89B8C] hover:text-[#D4AF37] transition-colors duration-200 mb-6 text-xs"
          data-testid="hero-instagram-link"
        >
          <Instagram className="w-3 h-3" />
          @nitikabhola_astro
        </a>

        {/* Main Headline — H1 */}
        <h1 className="font-['Cormorant_Garamond'] text-white text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight leading-[1.1] mb-4">
          Clarity, Guidance &amp;{' '}
          <span
            className="bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-transparent bg-clip-text"
            style={{ fontFamily: 'inherit', fontSize: 'inherit', fontWeight: 'inherit' }}
          >
            Personal Transformation
          </span>
        </h1>

        {/* Description */}
        <p className="font-['Inter'] text-base sm:text-lg text-[#C9C2B4] leading-relaxed mb-8 max-w-lg mx-auto">
          Personalised guidance through Astrology, Tarot, Kundali Analysis, Numerology and Name &amp; Mobile Number Correction — delivered on WhatsApp.
        </p>

        {/* Primary + Secondary CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <button
            onClick={handleBookConsult}
            className="font-['Inter'] inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black rounded-full shadow-[0_6px_24px_rgba(212,175,55,0.3)] hover:shadow-[0_8px_36px_rgba(212,175,55,0.45)] transition-shadow duration-300 w-full sm:w-auto text-[15px] font-semibold px-7 py-3.5"
            data-testid="hero-whatsapp-cta"
          >
            <MessageCircle className="w-4 h-4" />
            Book a Consultation on WhatsApp
          </button>

          <button
            onClick={scrollToServices}
            className="font-['Inter'] inline-flex items-center justify-center gap-2 border border-[#D4AF37]/50 hover:border-[#D4AF37] text-[#F3E5AB] hover:text-white rounded-full transition-colors duration-200 w-full sm:w-auto text-[14px] font-medium px-6 py-3.5"
            data-testid="hero-explore-cta"
          >
            Explore All Services
          </button>
        </div>
      </div>
    </section>
  );
};
